import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import CustomHeaderFooterQuery, {
	type CustomHeaderFooterQuery$data,
	type CustomHeaderFooterQuery$variables,
} from './__generated__/CustomHeaderFooterQuery.graphql';

export function preloadCustomHeaderAndFooter(spaceKey) {
	return query<CustomHeaderFooterQuery$data, CustomHeaderFooterQuery$variables>({
		query: CustomHeaderFooterQuery,
		variables: {
			spaceKey,
		},
	});
}
